import { flatten } from 'lodash-es';
import React from 'react';
import { BaseOperateView, BaseStagePlugin, getFramework, useIdentity, useIsLongImageMode } from '@/framework';
import { getLayerBoundingBox } from '@/utils/layer-kit';
import type { EdgelessFusionImagePlugin } from '../controller';
import { useFusionImageInit } from '../hooks/use-init';
import { useFusionImageState } from '../state';

export const EdgelessFusionImagePluginView: React.FC = React.memo(() => {
    const isLongImageMode = useIsLongImageMode();
    const identity = useIdentity();
    const framework = getFramework(identity);
    const originLayers = useFusionImageState()((state) => state.originLayers);
    const controller = framework.service.registration.getInstance<EdgelessFusionImagePlugin>('FusionImagePlugin');
    const panel = controller.getPanel();

    useFusionImageInit();

    // ATTENTION: 插件仅处理单画布的主图场景
    if (!originLayers || originLayers.length === 0 || isLongImageMode) return null;

    const layersBoundingBox = originLayers.map((layer) => getLayerBoundingBox(layer));
    const points = flatten(layersBoundingBox);

    const minX = Math.min(...points.map((point) => point[0]));
    const minY = Math.min(...points.map((point) => point[1]));
    const maxX = Math.max(...points.map((point) => point[0]));
    const maxY = Math.max(...points.map((point) => point[1]));

    return (
        <BaseStagePlugin enablePointerEvents style={{ zIndex: 3 }} name="fusion-image-plugin">
            <BaseOperateView
                layer={{
                    width: maxX - minX,
                    height: maxY - minY,
                    left: minX,
                    top: minY,
                    rotate: 0,
                }}
                offsetTop={0}
                offsetRight={0}
                style={{ position: 'relative' }}
            >
                <div
                    style={{
                        position: 'absolute',
                        left: '50%',
                        bottom: '0',
                        transform: 'translateX(-50%) translateY(100%)',
                        pointerEvents: 'all',
                    }}
                >
                    {panel}
                </div>
            </BaseOperateView>
        </BaseStagePlugin>
    );
});
